import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

/**
 * AuthCallback.jsx
 * Handles the OAuth redirect from Supabase after Google sign-in.
 * Supabase JS client auto-reads the #access_token hash from the URL.
 * We just wait for the session to be established, then redirect home.
 */
export default function AuthCallback() {
  const navigate = useNavigate()
  const [error, setError] = useState(null)

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_IN' && session) {
        navigate('/', { replace: true })
      } else if (event === 'SIGNED_OUT' || (!session && event !== 'INITIAL_SESSION')) {
        setError('Sign-in failed. Please try again.')
      }
    })
    const timeout = setTimeout(() => {
      setError('Sign-in timed out. Please try again.')
    }, 5000)
    return () => {
      subscription.unsubscribe()
      clearTimeout(timeout)
    }
  }, [navigate])

  const navy = '#0F2A4A'
  const gold = '#D4AF37'

  if (error) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: navy, fontFamily: 'system-ui, sans-serif' }}>
        <div style={{ background: '#FEF2F2', borderRadius: 12, padding: '32px 28px', maxWidth: 360, textAlign: 'center' }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#B91C1C', marginBottom: 12 }}>Sign-in Error</div>
          <div style={{ color: '#7F1D1D', fontSize: 14, marginBottom: 20 }}>{error}</div>
          <a href="/login" style={{ display: 'inline-block', padding: '10px 24px', background: navy, color: '#fff', borderRadius: 8, textDecoration: 'none', fontWeight: 600, fontSize: 14 }}>Try Again</a>
        </div>
      </div>
    )
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: navy, fontFamily: 'system-ui, sans-serif' }}>
      <div style={{ textAlign: 'center', color: '#fff' }}>
        <div style={{ width: 44, height: 44, border: `4px solid ${gold}`, borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 16px' }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
        <div style={{ fontSize: 16, fontWeight: 600 }}>Signing you in...</div>
        <div style={{ fontSize: 13, opacity: 0.6, marginTop: 6 }}>Just a moment</div>
      </div>
    </div>
  )
}
